import React from 'react';
import ReactDOM from 'react-dom/client'; 
import './index.css';
import RadioPlayer from './RadioPlayer';
import Weather from './Weather';
import AdSense from './Adsense';
import SocialLinks from './SocialLinks';

function Componente(props) {
  console.log(props);
  return (
    
    <div className="app-container">
      <Weather />
      <img className='img-perfil' src="https://d1fdloi71mui9q.cloudfront.net/JsjyLvbdRieJeaMVi3WS_1di3Esl2kevl8wl1" alt="Perfil de Radio Rock And More" role="presentation" data-testid="ProfileImage" style={{ filter: 'none' }}/>
      <h1>{props.titulo}</h1>  
      <p>{props.contenido}</p> 
      <SocialLinks />
      <AdSense />
      <RadioPlayer />
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Componente 
      titulo="ROCK AND MORE"  
      contenido="Creado para los Amantes de la Música 🎧"
    />
  </React.StrictMode>
);
